import { render } from "./MonitorGroupItem.vue?vue&type=template&id=dedba230&ts=true"
import script from "./MonitorGroupItem.vue?vue&type=script&lang=ts"
export * from "./MonitorGroupItem.vue?vue&type=script&lang=ts"
/* custom blocks */
import block0 from "./MonitorGroupItem.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/uv-fpark-w3prod05/uv-fpark-w3prod05.uio.no_80/htdocs/slplus-dev/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/admin/MonitorGroupItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "dedba230"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('dedba230', __exports__)) {
    console.log('reload')
    api.reload('dedba230', __exports__)
  }
  
  module.hot.accept("./MonitorGroupItem.vue?vue&type=template&id=dedba230&ts=true", () => {
    console.log('re-render')
    api.rerender('dedba230', render)
  })

}


export default __exports__